<app-row-header (toggleMenu)="toggleMenu()">{{ 'FOOTER.social_media' | translate }}</app-row-header>

@if (showMenuContent) {
    <div class="d-flex justify-content-start justify-content-lg-evenly">
        <a href="https://www.facebook.com/StelmachBizuteria/" target="_blank">
            <img src="/assets/images/icons/facebook-icon.png" width="30px" height="30px" class="social-icon" alt="Facebook" />
        </a>
        <a href="https://www.instagram.com/stelmach_pl/" target="_blank">
            <img src="/assets/images/icons/instagram-icon.png" width="30px" height="30px" class="social-icon ms-2" alt="Instagram" />
        </a>
    </div>
}
